<template>
  <div>
    <el-form ref="operationForm" :model="operationData" :rules="rules" label-width="100px">
      <el-form-item label="关联功能" prop="type">
        <el-select v-model="operationData.id" placeholder="请选择关联功能">
          <el-option v-for="item in selection" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="位置" prop="pos">
        <el-select v-model="operationData.pos" placeholder="请选择操作摆放位置" :disabled="!private">
          <el-option v-for="item in position" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="pos">
        <el-button type="primary" :disabled="currentRouterType === null" @click="jump()">快速访问</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cmsConfig from '../../../config/cmsConfig'
export default {
  name: 'operationConfig',
  props: {
    application: {
      type: Array,
      default() {
        return []
      }
    },
    operationData: {
      type: Object,
      default() {
        return {}
      }
    },
    private: {
      type: Boolean,
      default() {
        return true
      }
    },
    contentId: {}
  },
  data() {
    return {
      selection: [],
      position: [{
        id: 10,
        name: '左上'
      }, {
        id: 20,
        name: '右上'
      }, {
        id: 30,
        name: '左下'
      }],
      rules: {
        type: [
          { required: true, message: '请选择关联功能', trigger: 'blur' }
        ],
        pos: [
          { required: true, message: '请选择操作摆放位置', trigger: 'blur' }
        ]
      },
      currentRouterType: null // 当前路由类型
    }
  },
  methods: {
    selectOperation(item) {
      // console.log('item = ', item)
      if (this.operationData.type == item.type) {
        return
      }
      this.operationData.type = item.type
    },
    filterApplication() {
      let arr = []
      console.log(this.application)
      _(this.application).forEach((res) => {
        if (res.type != this.OPERATION_LIST &&
            res.type != this.OPERATION_CHART &&
            res.type != this.OPERATION_EXPORTWORD) { // 不是列表且不是图表不是导出word文档且非行内操作
          if (res.type == this.OPERATION_ADD &&
              res.config &&
              res.config.show_type != this.OPERATION_ADD) { // 是编辑或者详情
            return
          }
          arr.push(res)
        }
      })
      return arr
    },
    filterJumpRouter() { // 根据当前选择的类型判断跳转的路由类型
      if (this.operationData.type) {
        let type = this.operationData.type
        switch (type) {
          case this.OPERATION_ADD: // 编辑 添加 详情
            this.currentRouterType = 'formConfig'
            break
          case this.OPERATION_DELETE: // 删除
            this.currentRouterType = 'deleteConfig'
            break
          case this.OPERATION_IMPORT: // 导入
            this.currentRouterType = 'importConfig'
            break
          case this.OPERATION_EXPORT: // 导出
            this.currentRouterType = 'exportConfig'
            break
          case this.OPERATION_SEARCH: // 搜索
            this.currentRouterType = 'searchConfig'
            break
          case this.OPERATION_STATUS: // 一键修改字段值
            this.currentRouterType = 'statusConfig'
            break
          case this.OPERATION_FILTER: // 筛选标签
            this.currentRouterType = 'filterConfig'
            break
          case this.OPERATION_DOWNLOAD: // 下载
            this.currentRouterType = 'downloadConfig'
            break
          case this.OPERATION_MESSAGE: // 消息提醒
            this.currentRouterType = 'messageConfig'
            break
          case this.OPERATION_PARAMS: // 参数管理
            this.currentRouterType = 'paramsConfig'
            break
          case this.OPERATION_EXEC: // 执行函数
            this.currentRouterType = 'execConfig'
            break
          case this.OPERATION_IFRAME: // IFrame
            this.currentRouterType = 'iframeConfig'
            break
          default:
            this.currentRouterType = null
        }
      }
    },
    setOperation() {
      _(this.selection).forEach((res) => {
        if (res.id == this.operationData.id) {
          this.operationData.type = res.type
          this.operationData.iden = res.iden
          this.operationData.name = res.name
        }
      })
    },
    jump() {
      // 获取当前域名
      let host = window.location.host
      // console.log("当前域名：", host)
      // 中间固定参数
      let content = 'content'
      // 添加为配置路由
      // 在created中先判断当前选择的关联功能类型判断跳转路径 再根据选择的关联功能watch中判断当前类型
      // console.log('当前配置路由：', this.currentRouterType)
      // 获取当前contentId
      // console.log("当前contentId：", this.contentId)
      // 获取路由跳转参数
      // console.log('this.operationData', this.operationData)
      // 新的标签页打开
      let url = `/${content}/${this.currentRouterType}/${this.contentId}/${this.operationData.id}`
      window.open(url, '_blank')
    }
  },
  created() {
    this.selection = this.filterApplication()
    this.filterJumpRouter()
  },
  watch: {
    'private'() {
      this.selection = this.filterApplication()
    },
    'operationData.id'() {
      this.setOperation()
      this.filterJumpRouter()
    }
  },
  mixins: [cmsConfig]
}
</script>


// WEBPACK FOOTER //
// operationConfig.vue?b0077bf6